function OwnMessage({ message }) {
  return (
    <>
      <div className="own-message">
        <div className="own-message__bubble">
          <p className="own-message__text">{message}</p>

          <svg
            className="own-message__tail"
            width="8"
            height="18"
            viewBox="0 0 8 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 0C4.63158 4 1.68421 4.22222 0 4V18C2.52632 15.1111 7.15789 10.6667 8 0Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </>
  );
}

export default OwnMessage;
